import React from "react";

const steps = [
  {
    id: "01",
    title: "Grow",
    description: "Single-origin lots grown in Rulindo, Kamonyi, or Karongi—kept separate, never blended.",
    image: "/Coffee30.jpg",
  },
  {
    id: "02",
    title: "Harvest",
    description: "Handpicked at peak ripeness by women farmers.",
    image: "/Coffee31.jpg",
  },
  {
    id: "03",
    title: "Wash",
    description: "Washed with pure water and dried on raised beds.",
    image: "/Coffee32.jpg",
  },
  {
    id: "04",
    title: "Roast",
    description: "Small batch roasted for unique flavor and aroma.",
    image: "/Coffee33.jpg",
  },
  {
    id: "05",
    title: "Pack",
    description: "Sealed soon after roast to lock in freshness.",
    image: "/kbl-bag.png",
  },
  {
    id: "06",
    title: "Enjoy",
    description: "Delivered fresh for the perfect cup at home.",
    image: "/Coffee9.jpg",
  },
];

const Journey = () => {
  return (
    <section className="bg-cream px-5 py-16 md:px-8 md:py-20 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-gold">
            From Farm to Cup
          </p>
          <h2 className="mt-3 font-display text-3xl text-espresso md:text-4xl">
            A Journey of Care
          </h2>
        </div>

        <div className="relative">
          <svg
            className="pointer-events-none absolute left-0 right-0 top-16 hidden h-16 w-full text-gold/50 lg:block"
            viewBox="0 0 1200 80"
            fill="none"
            preserveAspectRatio="none"
            aria-hidden
          >
            <path
              d="M40 40 C 140 10, 200 70, 280 40 S 440 10, 520 40 S 680 70, 760 40 S 920 10, 1000 40 S 1120 70, 1160 40"
              stroke="currentColor"
              strokeWidth="2"
              strokeDasharray="6 8"
            />
          </svg>

          <div className="relative z-10 grid gap-10 sm:grid-cols-2 lg:grid-cols-6">
            {steps.map((step) => (
              <div key={step.id} className="flex flex-col items-center text-center">
                <div className="relative mb-4">
                  <div className="h-24 w-24 overflow-hidden rounded-full border-[3px] border-cream shadow-md md:h-28 md:w-28">
                    <img
                      src={step.image}
                      alt={step.title}
                      className="h-full w-full object-cover"
                    />
                  </div>
                  <span className="absolute -left-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full bg-espresso font-display text-[11px] text-gold shadow">
                    {step.id}
                  </span>
                </div>
                <h3 className="font-display text-xl text-espresso">{step.title}</h3>
                <p className="mt-2 max-w-[10.5rem] text-sm leading-snug text-cocoa">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Journey;
